import React from "react";
import { PortfolioProperty } from "../types/ownerPortfolio.types";
import InspectionAction from "./InspectionAction";
import PortfolioSidebar from "./PortfolioSidebar";

interface InspectionSidebarProps {
  property: PortfolioProperty;
  accessToken: string | null;
  onClose: () => void;
}

export default function InspectionSidebar({
  property,
  accessToken,
  onClose,
}: InspectionSidebarProps) {
  return (
    <PortfolioSidebar
      property={property}
      title="Vistoria"
      closeLabel="Fechar vistoria"
      testId="inspection-sidebar"
      titleId="inspection-sidebar-title"
      onClose={onClose}
    >
      <InspectionAction
        kenloPropertyId={property.kenlo_property_id}
        accessToken={accessToken}
      />
    </PortfolioSidebar>
  );
}
